import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "app-language-selector__current" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "app-language-selector__code hide-mobile" }
const _hoisted_5 = {
  key: 0,
  class: "app-language-selector__menu-wrapper"
}
const _hoisted_6 = { class: "app-language-selector__menu" }

import { computed, ref, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '@/i18n'

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

/// <reference types="vue" />
// @ts-ignore
const menuVisible = ref<boolean>(false)
const languageSelectorRef = ref<HTMLElement | null>(null)

// i18n
const { locale } = useI18n()

// Computed properties
const currentLanguage = computed((): string => {
  return locale.value
})

const currentLanguageFlag = computed((): string => {
  switch(currentLanguage.value) {
    case 'en': return '/assets/flags/england.svg'
    case 'fr': return '/assets/flags/france.svg'
    case 'ar': return '/assets/flags/tunisia.svg'
    default: return '/assets/flags/england.svg'
  }
})

// Methods
const toggleLanguageMenu = (): void => {
  menuVisible.value = !menuVisible.value
  if (menuVisible.value) {
    // Add event listeners to detect clicks outside and Escape presses
    document.addEventListener('click', handleClickOutside)
    document.addEventListener('keydown', handleKeydown)
  } else {
    removeMenuEventListeners()
  }
}

const closeLanguageMenu = (): void => {
  menuVisible.value = false
  removeMenuEventListeners()
}

const removeMenuEventListeners = (): void => {
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('keydown', handleKeydown)
}

const changeLanguage = (lang: string): void => {
  try {
    // Make sure the language code is valid
    if (!['en', 'fr', 'ar'].includes(lang)) {
      return
    }

    // Call the setLocale function
    setLocale(lang)

    // Double check that the language was actually changed
    if (window.i18n && window.i18n.global && window.i18n.global.locale.value !== lang) {
      // Direct set as fallback
      window.i18n.global.locale.value = lang
    }

    closeLanguageMenu()
  } catch (e) {
    // Silent error handling
  }
}

const handleClickOutside = (event: MouseEvent): void => {
  // Check if clicked outside of the language selector
  if (languageSelectorRef.value && !languageSelectorRef.value.contains(event.target as Node)) {
    closeLanguageMenu()
  }
}

const handleKeydown = (event: KeyboardEvent): void => {
  if (event.key === 'Escape') {
    closeLanguageMenu()
  }
}

// Lifecycle
onBeforeUnmount(() => {
  // Clean up event listeners
  removeMenuEventListeners()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "app-language-selector",
    ref_key: "languageSelectorRef",
    ref: languageSelectorRef
  }, [
    _createElementVNode("button", {
      onClick: toggleLanguageMenu,
      class: "app-language-selector__btn",
      title: _ctx.$t('common.language')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: currentLanguageFlag.value,
          alt: currentLanguage.value,
          class: "app-language-selector__flag"
        }, null, 8, _hoisted_3),
        _createElementVNode("span", _hoisted_4, _toDisplayString(currentLanguage.value.toUpperCase()), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("svg", {
        class: "app-language-selector__dropdown-icon",
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M1 1L5 5L9 1",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1))
    ], 8, _hoisted_1),
    _createVNode(_Transition, { name: "app-menu-fade" }, {
      default: _withCtx(() => [
        (menuVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLanguage('en'))),
                  class: _normalizeClass([{ 'app-language-selector__item--active': currentLanguage.value === 'en' }, "app-language-selector__item"])
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("img", {
                    src: "/assets/flags/england.svg",
                    alt: "English",
                    class: "app-language-selector__flag"
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.english')), 1)
                ], 2),
                _createElementVNode("li", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLanguage('fr'))),
                  class: _normalizeClass([{ 'app-language-selector__item--active': currentLanguage.value === 'fr' }, "app-language-selector__item"])
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                    src: "/assets/flags/france.svg",
                    alt: "French",
                    class: "app-language-selector__flag"
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.french')), 1)
                ], 2),
                _createElementVNode("li", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeLanguage('ar'))),
                  class: _normalizeClass([{ 'app-language-selector__item--active': currentLanguage.value === 'ar' }, "app-language-selector__item"])
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("img", {
                    src: "/assets/flags/tunisia.svg",
                    alt: "Arabic",
                    class: "app-language-selector__flag"
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.arabic')), 1)
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})